
export const EnvNames = {
  local: 'local',
  development: 'development',
  staging: 'staging',
  production: 'production',
  demo: 'demo',
} as const

export const PUBLIC_URLS = {
  local: process.env.NEXT_PUBLIC_URL ?? 'https://localhost:3000',
  development: 'https://app.dev.smooth.jp',
  staging: 'https://app.dev.smooth.jp',
  production: 'https://app.smooth.jp',
  demo: 'https://app.demo.smooth.jp',
} as const

export const GTA_IDS = {
  local: 'G-D07BF1DJDD',
  development: 'G-D07BF1DJDD',
  production: 'G-KRGKV8CNHG',
  demo: 'G-D07BF1DJDD',
} as const

export const CONTENTFUL_PROPS_VALUES = {
  local: {
    spaceId: 'farmtz7r01oh',
    accessToken: 't3nhz112-xIsZbPTC27CCWKHqDGsd44zcfGnkecX1bY',
  },
  development: {
    spaceId: 'farmtz7r01oh',
    accessToken: 't3nhz112-xIsZbPTC27CCWKHqDGsd44zcfGnkecX1bY',
  },
  production: {
    spaceId: 'farmtz7r01oh',
    accessToken: 't3nhz112-xIsZbPTC27CCWKHqDGsd44zcfGnkecX1bY',
  },
  demo: {
    spaceId: 'farmtz7r01oh',
    accessToken: 't3nhz112-xIsZbPTC27CCWKHqDGsd44zcfGnkecX1bY',
  },
} as const


export const SMOOTH_LINE_API_URLS = {
  local: process.env.NEXT_PUBLIC_SMOOTH_API_URL ?? 'http://localhost:13001',
  development: 'https://api.app.dev.smooth.jp',
  production: 'https://api.app.smooth.jp',
  demo: 'https://api.app.demo.smooth.jp',
} as const


export const FB_APP_IDS = {
  local: '2241835442743796',
  development: '2241835442743796',
  production: '2241835442743796',
  demo: '2241835442743796',
} as const

export const LIFF_IDS = {
  local: process.env.NEXT_PUBLIC_LIFF_ID ?? '1653344542-BJpDY91N',
  development: '1653344542-BJpDY91N',
  production: '1653845526-0eGJGLyn',
  demo: '2008870468-cdF5C0aj',
} as const

export const LINE_FRIEND_URLS = {
  local: 'https://line.me/R/ti/p/%40868qoekz',
  development: 'https://line.me/R/ti/p/%40567wqmmj',
  production: 'https://line.me/R/ti/p/%40167scnqz',
  demo: 'https://line.me/R/ti/p/%40686qvqmj',
} as const

// レガシーではあるが、これでないと例えばAndroid版TikTokのアプリ内ブラウザからLIFFに遷移しないので、
// 流入経路を把握しつつCVRをキープするためにとても重要
export const LEGACY_EFFECTIVE_LIFF_URLS = {
  local: 'line://app/2000786098-NPopmmLG',
  development: 'line://app/1653344542-BJpDY91N',
  production: 'line://app/1653845526-0eGJGLyn',
  demo: 'line://app/1653344542-BJpDY91N',
} as const

export const SLACK_ERROR_WEBHOOK_URLS = {
  local: 'https://hooks.slack.com/services/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',
  development: 'https://hooks.slack.com/services/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',
  production: 'https://hooks.slack.com/services/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',
  demo: 'https://hooks.slack.com/services/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',
} as const

export type SplitOptions = {
  name: string
  value: number
  annual_interest_rate: number
}
export const SPLIT_OPTIONS_OLD_PLAN: SplitOptions[] = [
  {
    name: '3回 分割手数料 実質年率0%',
    value: 3,
    annual_interest_rate: 0
  },
  {
    name: '6回 分割手数料 実質年率15.0%',
    value: 6,
    annual_interest_rate: 0.15,
  },
  {
    name: '12回 分割手数料 実質年率15.0%',
    value: 12,
    annual_interest_rate: 0.15,
  },
  {
    name: '24回 分割手数料 実質年率15.0%',
    value: 24,
    annual_interest_rate: 0.15,
  },
  {
    name: '36回 分割手数料 実質年率15.0%',
    value: 36,
    annual_interest_rate: 0.15,
  },
  {
    name: '48回 分割手数料 実質年率15.0%',
    value: 48,
    annual_interest_rate: 0.15,
  },
]

export const SPLIT_OPTIONS_NEW_PLAN: SplitOptions[] = [
  {
    name: '3回 分割手数料 実質年率18.0%',
    value: 3,
    annual_interest_rate: 0.18,
  },
  {
    name: '6回 分割手数料 実質年率18.0%',
    value: 6,
    annual_interest_rate: 0.18,
  },
  {
    name: '12回 分割手数料 実質年率18.0%',
    value: 12,
    annual_interest_rate: 0.18,
  },
  {
    name: '24回 分割手数料 実質年率18.0%',
    value: 24,
    annual_interest_rate: 0.18,
  },
  {
    name: '36回 分割手数料 実質年率18.0%',
    value: 36,
    annual_interest_rate: 0.18,
  },
  {
    name: '48回 分割手数料 実質年率18.0%',
    value: 48,
    annual_interest_rate: 0.18,
  },
]

export const MIXPANEL_TOKEN = {
  local: 'd87525ef1f00a370b09998d116866427',
  development: '4fdffab74940a76dad7983c0f1c101e4',
  production: 'fd70c0d485338c52c4425eff84d9587b',
  demo: 'd87525ef1f00a370b09998d116866427',
} as const

export const LOGROCKET_ORGS = {
  local: 'ugjwss/smooth-liff-dev',
  development: 'ugjwss/smooth-liff-dev',
  production: 'ugjwss/smooth-liff',
  demo: 'ugjwss/smooth-liff-dev',
}
